import { StubTabBody, StubTabRow } from "./_StubTab";

export function StageTab(): JSX.Element {
  return (
    <StubTabBody summary="Stage / plaque sanity check. Reads what every wall plaque is currently rendering so a stream-day check can be done in one place.">
      <StubTabRow
        label="current stage label"
        hint="Render whatever the lobby's GENESIS / OPEN PLAYTEST plaque is showing right now."
      />
      <StubTabRow
        label="roadmap plaque content"
        hint="Mirror the wall roadmap items + their done/not-done state. Lets you preview a stage flip before pushing."
      />
      <StubTabRow
        label="king nameplate / token sign / timer plaque"
        hint="Dump each diegetic plaque's current text. Catches the case where one plaque is stale while others updated."
      />
      <StubTabRow
        label="rules board content"
        hint="Show the rules text from the in-world board so it can be proofread without walking the camera over to it."
      />
    </StubTabBody>
  );
}
